import React, { PureComponent, Fragment } from 'react'
import { object, number, func, shape, oneOfType } from 'prop-types'
import { SvgPathLine } from 'components'
import { xRange, applyFactor, performanceVsDeteriorationPoints } from 'utils/chartFunctions'
import { SvgPoint } from './SvgPoint'

export class PreRacePerformanceLine extends PureComponent {
    static propTypes = {
        curveParams: object.isRequired,
        outputViewBox: shape({
            x: number.isRequired,
            y: number.isRequired,
            width: number.isRequired,
            height: number.isRequired
        }).isRequired,
        factors: shape({
            x: oneOfType([number, func]),
            y: oneOfType([number, func])
        }),
        pointMarker: number,
        dashLineMarker: number,
    }
    static defaultProps = {
        factors: {}
    }

    componentWillMount() {
        this.refreshLineData(this.props)
        this.refreshPointMarkerData(this.props)
        this.refreshDashLineMarkerData(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.curveParams !== this.props.curveParams || nextProps.factors !== this.props.factors) {
            this.refreshLineData(nextProps)
            this.refreshPointMarkerData(nextProps)
            this.refreshDashLineMarkerData(nextProps)
        } else {
            if (nextProps.pointMarker !== this.props.pointMarker) {
                this.refreshPointMarkerData(nextProps)
            }
            if (nextProps.dashLineMarker !== this.props.dashLineMarker) {
                this.refreshDashLineMarkerData(nextProps)
            }
        }
    }

    refreshLineData = props => {
        const { curveParams, factors } = props
        this.lineData = getLineData(curveParams, factors)
    }
    refreshPointMarkerData = props => {
        const { pointMarker, curveParams, factors } = props
        this.pointMarkerData = typeof pointMarker === 'number' ? getPointData(pointMarker, curveParams, factors) : null
    }
    refreshDashLineMarkerData = props => {
        const { dashLineMarker, curveParams, factors } = props
        this.dashLineMarkerData = typeof dashLineMarker === 'number' ? getPointData(dashLineMarker, curveParams, factors) : null
    }

    render() {
        const { curveParams, outputViewBox, factors, pointMarker, dashLineMarker, className, clipPath, ...otherProps } = this.props
        return (
            <Fragment>
                <SvgPathLine
                    className={['ChartLine Performance', className]}
                    data={this.lineData}
                    inputRange={{ x: [0, 1], y: [0, 1] }}
                    outputViewBox={outputViewBox}
                    interpolated
                    startAnimation="fromBottom"
                    clipPath={clipPath}
                    {...otherProps}
                />
                {this.dashLineMarkerData && (
                    <SvgPathLine
                        className="DashLine"
                        data={[{ x: this.dashLineMarkerData.x, y: 0 }, { x: this.dashLineMarkerData.x, y: 1 }]}
                        inputRange={{ x: [0, 1], y: [0, 1] }}
                        outputViewBox={outputViewBox}
                        clipPath={clipPath}
                    />
                )}
                {this.pointMarkerData && (
                    <SvgPoint
                        data={this.pointMarkerData}
                        inputRange={{ x: [0, 1], y: [0, 1] }}
                        outputViewBox={outputViewBox}
                    />
                )}
            </Fragment>
        )
    }
}

function getLineData(curveParams, factors = {}) {
    return performanceVsDeteriorationPoints(xRange(factors.x ? 1 / factors.x : 1), curveParams).map(({ x, y }) => ({
        x: applyFactor(factors.x, x),
        y: applyFactor(factors.y, y)
    }))
}
function getPointData(x, curveParams, factors = {}) {
    return performanceVsDeteriorationPoints([(factors.x || 1) * x], curveParams).map(({ x, y }) => ({
        x: Math.min(Math.max(applyFactor(factors.x, x), 0), 1),
        y: Math.min(Math.max(applyFactor(factors.y, y), 0), 1)
    }))[0]
}



// WEBPACK FOOTER //
// src/components/Svg/PreRacePerformanceLine.js